import DOMPurify from 'dompurify';

const safeUrl = value => /^(https?:\/\/|mailto:)/i.test(value || '');
export const sanitizeInvoiceNotesHtml = value => {
  const container = document.createElement('div');
  container.innerHTML = DOMPurify.sanitize(String(value || ''), {
    ALLOWED_TAGS:['p','div','br','b','strong','i','em','span','font','a'],
    ALLOWED_ATTR:['href','style','color'],
  });
  container.querySelectorAll('*').forEach(element => {
    const href = element.getAttribute('href');
    const color = element.style.color || (element.tagName === 'FONT' ? element.getAttribute('color') : '');
    const bold = /^(bold|[6-9]00)$/.test(element.style.fontWeight);
    const italic = element.style.fontStyle === 'italic';
    [...element.attributes].forEach(attribute => element.removeAttribute(attribute.name));
    let target = element;
    if (element.tagName === 'FONT') {
      target = document.createElement('span');
      target.append(...element.childNodes); element.replaceWith(target);
    }
    if (target.tagName === 'A' && safeUrl(href)) target.setAttribute('href',href);
    if (/^(#[\da-f]{3}(?:[\da-f]{3})?|rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\))$/i.test(color || '')) target.style.color = color;
    if (bold) target.style.fontWeight = 'bold';
    if (italic) target.style.fontStyle = 'italic';
  });
  return container.innerHTML;
};

export const invoiceNotesVisibleText = html => {
  const root = document.createElement('div');root.innerHTML = sanitizeInvoiceNotesHtml(html);
  let result = '';
  const newline = () => {if(result && !result.endsWith('\n')) result+='\n';};
  const visit = node => {
    if(node.nodeType === 3) {
      let text = node.textContent.replace(/[\s\u00a0]+/g,' ');
      if(!result || /[ \n]$/.test(result)) text = text.replace(/^ +/,'');
      result+=text;return;
    }
    if(['P','DIV','BR'].includes(node.nodeName)) newline();
    node.childNodes.forEach(visit);
    if(['P','DIV'].includes(node.nodeName)) newline();
  };
  root.childNodes.forEach(visit);
  return result.trimEnd();
};
export const invoiceNotesCharacterCount = html => Array.from(invoiceNotesVisibleText(html)).length;
export const isSafeInvoiceNotesUrl = safeUrl;
